// Un déploiement remplace les fichiers de l'app par de nouveaux noms : un onglet
// resté ouvert sur l'ancienne version demande alors des « chunks » qui n'existent
// plus (ChunkLoadError). Un rechargement suffit à récupérer la nouvelle version.
// Garde-fou sessionStorage : un seul essai par minute, pour ne jamais boucler si le
// fichier manque pour une autre raison (celle-là reste remontée en erreur).

const CHUNK_RELOAD_AT_KEY = 'liberio.chunk-reload-at';
const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const record = error as { name?: unknown; message?: unknown };
  const name = typeof record.name === 'string' ? record.name : '';
  const message = typeof record.message === 'string' ? record.message : '';
  return name === 'ChunkLoadError' || /Loading (CSS )?chunk .+ failed/i.test(message);
}

export function canAutoReloadForStaleChunk(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_AT_KEY) || '0');
    return Date.now() - lastReloadAt >= CHUNK_RELOAD_COOLDOWN_MS;
  } catch {
    // Stockage indisponible (navigation privée stricte) : impossible de garantir
    // l'absence de boucle, on ne recharge pas automatiquement.
    return false;
  }
}

export function reloadForStaleChunk() {
  try {
    window.sessionStorage.setItem(CHUNK_RELOAD_AT_KEY, String(Date.now()));
  } catch {
    return;
  }
  window.location.reload();
}

// Les échecs de chunk hors rendu React (import() différé, préchargement) arrivent en
// promesse rejetée globale, jamais dans une error boundary : on les écoute ici.
export function registerStaleChunkAutoReload() {
  if (typeof window === 'undefined') {
    return;
  }
  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason) && canAutoReloadForStaleChunk()) {
      event.preventDefault();
      reloadForStaleChunk();
    }
  });
}
